module.exports = __webpack_public_path__ + "assets/img/coin-gct-bj-1.32de8d2b.jpg";